export default __webpack_public_path__ + "static/media/6d47b27eaf48366a69c602e9cdaafd301581510461857.4a668e13.webp";